import React, { Component } from 'react';
import uuidv4 from 'uuid/v4';
import { connect } from 'react-redux';
import { Card } from 'semantic-ui-react';
import WeatherListItem from '../components/WeatherListItem';

class WeatherList extends Component {
	render() {
		const localWeather = JSON.parse(localStorage.getItem('localWeather'));
		if (localWeather && localWeather.length > 0) {
			return (
				<Card.Group
					id="weather-list"
					stackable
					itemsPerRow={2}
					style={{ marginTop: '10px', marginBottom: '20px' }}
				>
					{localWeather.map(data => (
						<WeatherListItem data={data} key={uuidv4()} />
					))}
				</Card.Group>
			);
		}
		return null;
	}
}

const mapStateToProps = ({ weather }) => ({ weather });

export default connect(mapStateToProps)(WeatherList);



// WEBPACK FOOTER //
// ./src/containers/WeatherList.js